// extracted by mini-css-extract-plugin
export default {"addMember":"vip_addMember__rewWS","modalTitle":"vip_modalTitle__v4Iy+","buttons":"vip_buttons__GOO5Y"};